import {
  aslanSources,
  busterSources,
  candySources,
  charleySources,
  duncanSources,
  elvisSources,
  francisSources,
  gabiSources,
  ghostSources,
  gingerSources,
  gretaSources,
  jacSources,
  jaxSources,
  kennySources,
  kimberSources,
  kodaSources,
  loki1Sources,
  lokiSources,
  lunaSources,
  macyAndLillySources,
  maxSources,
  maySources,
  miaSources,
  mikaSources,
  mikeySources,
  mochiSources,
  oogieSources,
  oscarSources,
  riverSources,
  rockySources,
  simba1Sources,
  simbaSources,
  treSources,
  unoSources,
  vivienneKissesSources,
  winnieSources,
} from './assets';

export const ImageMarqueeItemsOne = [
  {
    name: 'Aslan',
    state: 'IN',
    sources: aslanSources,
  },
  {
    name: 'Buster',
    state: 'CA',
    sources: busterSources,
  },
  {
    name: 'Candy',
    state: 'VA',
    sources: candySources,
  },
  {
    name: 'Rocky',
    state: 'FL',
    sources: rockySources,
  },
  {
    name: 'Jac',
    state: 'NC',
    sources: jacSources,
  },
  {
    name: 'Kimber',
    state: 'GA',
    sources: kimberSources,
  },
  {
    name: 'Loki',
    state: 'LA',
    sources: lokiSources,
  },
  {
    name: 'Koda',
    state: 'NJ',
    sources: kodaSources,
  },
  {
    name: 'Max',
    state: 'IL',
    sources: maxSources,
  },
  {
    name: 'Mika',
    state: 'CA',
    sources: mikaSources,
  },
  {
    name: 'Mochi',
    state: 'NJ',
    sources: mochiSources,
  },
  {
    name: 'River',
    state: 'IN',
    sources: riverSources,
  },
];

export const ImageMarqueeItemsTwo = [
  {
    name: 'Charley',
    state: 'MN',
    sources: charleySources,
  },
  {
    name: 'Ghost',
    state: 'NV',
    sources: ghostSources,
  },
  {
    name: 'Duncan',
    state: 'PA',
    sources: duncanSources,
  },
  {
    name: 'Ginger',
    state: 'GA',
    sources: gingerSources,
  },

  {
    name: 'Jax',
    state: 'FL',
    sources: jaxSources,
  },
  {
    name: 'May',
    state: 'FL',
    sources: maySources,
  },
  {
    name: 'Mia',
    state: 'CA',
    sources: miaSources,
  },
  {
    name: 'Mikey',
    state: 'FL',
    sources: mikeySources,
  },
  {
    name: 'Oogie',
    state: 'NY',
    sources: oogieSources,
  },
  {
    name: 'Simba',
    state: 'TX',
    sources: simba1Sources,
  },
  {
    name: 'Tre',
    state: 'FL',
    sources: treSources,
  },
  {
    name: 'Uno',
    state: 'TN',
    sources: unoSources,
  },
];

export const ImageMarqueeItemsThree = [
  {
    name: 'Elvis',
    state: 'MA',
    sources: elvisSources,
  },
  {
    name: 'Francis',
    state: 'CA',
    sources: francisSources,
  },
  {
    name: 'Gabi',
    state: 'FL',
    sources: gabiSources,
  },
  {
    name: 'Greta',
    state: 'PA',
    sources: gretaSources,
  },
  {
    name: 'Kenny',
    state: 'CA',
    sources: kennySources,
  },
  {
    name: 'Loki',
    state: 'AZ',
    sources: loki1Sources,
  },
  {
    name: 'Luna',
    state: 'FL',
    sources: lunaSources,
  },
  {
    name: 'Macy & Lilly',
    state: 'NY',
    sources: macyAndLillySources,
  },
  {
    name: 'Oscar',
    state: 'NH',
    sources: oscarSources,
  },
  {
    name: 'Simba',
    state: 'CA',
    sources: simbaSources,
  },
  {
    name: 'Vivienne Kisses',
    state: 'NV',
    sources: vivienneKissesSources,
  },
  {
    name: 'Winnie',
    state: 'CA',
    sources: winnieSources,
  },
];
